import { deprecatedTimezoneMap } from '$/shared/frontend/utils/tzDeprecated';

type Nullable<T> = T | null | undefined;

type GetTimezoneReturnType<T extends Nullable<string>> = T extends string ? string : T;
export const canonicalTz = <T extends Nullable<string> = Nullable<string>>(
  timezone: T
): GetTimezoneReturnType<T> => {
  if (typeof timezone === 'string') {
    const tz: string = deprecatedTimezoneMap[timezone] || timezone;
    return tz as GetTimezoneReturnType<T>;
  }
  return undefined as GetTimezoneReturnType<T>;
};
